import { DropDownButtonV2 } from "./DropDownButton";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SelectPopover from "../../atoms/SelectPopover/SelectPopover";

type ContryDropdownType = {
  iso: string;
  name: string;
  hideTitle?: boolean;
};
export type CountryDropdownProps = {
  display: string;
  options?: ContryDropdownType[];
  onChange?: (index: number, value: any) => void;
  value?: any;
  fullWidth?: boolean;
  hideTitle?: boolean;
};
const CountryWithFlag = ({ iso, name, hideTitle }: ContryDropdownType) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.625rem" }}>
      <Box
        component={"img"}
        src={`https://suregifts.blob.core.windows.net/shared/${iso.toLowerCase()}.png`}
        sx={{
          width: "1.5rem",
          height: "1.5rem",
          borderRadius: "0.75rem",
        }}
      />
      {!hideTitle && <span>{name}</span>}
    </div>
  );
};
export const CountryDropdown = ({
  options = [],
  hideTitle = false,
  value,
  onChange = () => {},
  ...others
}: Omit<CountryDropdownProps, "display">) => {
  const [localDisplay, setLocalDisplay] = useState<React.ReactNode>();

  useEffect(() => {
    if (!options || !value) return;
    const index = options.findIndex((x) => x.iso.toLowerCase() === value.toLowerCase());
    setLocalDisplay(<CountryWithFlag {...options[index]} hideTitle={hideTitle} />);
  }, [options, value]);

  return (
    <>
      <SelectPopover
        options={options?.map((x) => ({ text: x.name, value: x.iso }))}
        onChange={onChange}
        render={(handleClick) => <DropDownButtonV2 onClick={handleClick} display={localDisplay} {...others} className="country-dropdown" />}
      ></SelectPopover>
    </>
  );
};
export default CountryDropdown;
